import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient, HttpHeaders} from '@angular/common/http';
import {map} from 'rxjs/operators';

const contentHeader = new HttpHeaders(
  {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0'
  });

@Injectable({
  providedIn: 'root'
})
export class MsalConfigService {

  private settings: any;
  private http: HttpClient;
  constructor(private readonly httpHandler: HttpBackend) {
    this.http = new HttpClient(httpHandler);
  }

  init(endpoint: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.http.get(endpoint , { headers: contentHeader }).pipe(map(res => res))
        .subscribe(value => {
            this.settings = value;
            resolve(true);
          },
          (error) => {
            reject(error);
          });
    });
  }

  getSettings(key?: string | Array<string>): any {
    if (!key || (Array.isArray(key) && !key[0])) {
      return this.settings;
    }

    if (!Array.isArray(key)) {
      key = key.split('.');
    }

    return key.reduce((acc: any, current: string) => acc && acc[current], this.settings);
  }
}
